$(document).ready(function() {

    if(window.location.href.indexOf("refer") > -1 || window.location.href.indexOf("rewards") > -1) {
      $('body').addClass("swell-rewards-page");
    }

    $("body").on("click", ".close-thank-you", function(){
      $(".swell-post-checkout-sleeknail").remove();
    });
  $(document).on("swell:initialized", function() {

    SwellConfig.Redemption.initializeRedemptions(".swell-redemption-option-list");
    SwellConfig.Redemption.initializeProductRedemptions(".swell-redemption-product-list");

    // Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
    var campaigns = spapi.activeCampaigns;
    campaigns.forEach(function(campaign) {
      if (campaign.type != "ReferralCampaign") {
        $(".swell-campaign-list").append("<li class='swell-campaign'> <div class='swell-campaign-link' data-display-mode='modal' data-campaign-id='" + campaign.id + "'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='" + campaign.icon + "'> <span class='path1'></span><span class='path2'></span><span class='path3'></span><span class='path4'></span><span class='path5'></span></i> </span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'>" + campaign.reward_text + "</span> </div> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'>" + campaign.title + "</span> </div> </div> </li>");
      }
    });
    //$(".swell-campaign-list").append('<li class="swell-campaign custom-campaign"> <div class="swell-campaign-link" data-display-mode="modal" data-campaign-id="527752"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"> <i class="swell-icon-share-on-facebook"> <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></i> </span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">SLEEK</span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">Nail</span> </div> </div> </li>');

    $(".swell-referral-init-loader").remove();
  });

  $(document).on("swell:setup", function() {
    $(".swell-post-checkout-sleeknail").css("display","flex");
    $(".swell-referral-loader").remove();

     $(document).on("swell:cart:updated", function(){
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          async: false,
          cache: false,
          dataType: 'json',
          success: updateCartDesc
        });
      });

     $("body").on("click", ".swell-keep-shopping-btn", function() {
      location.reload();
     });

      $(document).on("swell:cart:updated", function(){
        var cart = $.ajax({
          type: 'GET', 
          url: '/cart.js',
          dataType: 'json',
          success: function(){
            if(cart.responseJSON.item_count>0){
              var isPricedItem = 0;
              cart.responseJSON.items.forEach(function(item)
              {
                if(item.final_price > 0)
                {
                  if(item.properties["_swell_discount_type"] === undefined)
                  {
                    isPricedItem = 1;
                    return false;
                  }
                }
              });
              if(isPricedItem == 0)
              {
                window.location.href = "/cart/clear";
              }
            }
          }
        });
      });

    window.onBeforeProductRedemption = function(opts, redemptionOption, pointBalance, cb){
    if (Swell.Cart.items.length == 0) {
      content = "Your cart cannot be empty in order to redeem awards"
      spapi.$.confirm({
        title: "Oops!",
        content: content,
        type: "red",
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {
            }
          }
        }
      });
    } else {
      cb();
    }
  };
  
    SwellConfig.Referral.initializeReferral(".swell-referral");
    SwellConfig.Tier.initializeCustomTierProperties();
    SwellConfig.Tier.initializeTiers(".vip-earn-table");


  });
  
  // $(document).on("click", ".swell-product-redemption", function(e) {

  //   $("#redemption-model #swell-reward-heading").html('');
  //   $("#redemption-model #swell-coupon-intro").html('');
  //   $("#redemption-model #swell-reward-intro").html('');
  //   $("#redemption-model #swell-coupon-code").html('');

  //   var elementDiv = $(e.target).closest(".swell-redemption-option");
  //   var redID = $(e.target).attr("data-redemption-option-id");
  //   var redemption = swellAPI.findActiveRedemptionOptionById(redID);
  //   var stringText = `Are you sure you want to add this product? <button class="redeem-confirm" data-redemption-id=${redID}>Redeem</button>`;

  //   $("#swell-reward-heading").html(`${redemption.name}`);
  //   $("#swell-reward-intro").html(stringText);
  //   $('#redemption-model').css("display", "flex");
  // });

  // $(document).on("click", ".redeem-confirm", function(e) {
  //   $(".redeem-confirm").html('<i class="fa fa-spin fa-spinner"></i>');
  //   var redID = $('.redeem-confirm').data('redemption-id');

  //   var onSuccess = function(redemption) {
  //     var data = Swell.Cart.wrapProperties();
  //     data.id = redemption.redemptionOption.variant_ids[0];
  //     data.quantity = 1;
      
  //     $.ajax({
  //       url: '/cart/add.js',
  //       data: data,
  //       type: "POST",
  //       dataType: 'json',
  //       success: ()=>{ console.log("successfully  product");},
  //       error: ()=>{ console.log("Error adding product");}
  //     });

  //     $(".redeem-confirm").html('Redeem');
  //     $("#redemption-model #swell-reward-heading").html(redemption.redemptionOption.name);
  //     $("#redemption-model #swell-coupon-intro").html(redemption.redemptionOption.description);
  //     $("#redemption-model #swell-reward-intro").html(redemption.redemptionOption.reward_intro);
  //     $("#redemption-model #swell-coupon-code").html(redemption.couponCode);
      
  //   }

  //   var onError = function(err) {
  //     $(".redeem-confirm").html('Redeem');
  //     $("#swell-reward-intro").html(`<span style="color: red;">Oops, it seems you do not have enough points to redeem or try again. </span>`);
  //   };

  //   swellAPI.makeRedemption(
  //     { redemptionOptionId: redID },
  //     onSuccess,
  //     onError
  //   );
  // })


  // $("body").on('click', '.close', function() {
  //   $('#redemption-model').css("display", "none");
  // });

  $(document).on("swell:referral:success", function() {
    SwellConfig.Referral.populateReferrals();
  });

  $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
    let emails = $("#swell-referral-refer-emails").val();
    $(".refer-customer-error").remove();
    if (emails.indexOf(spapi.customer.email) > -1 ) {
      $("<p class=\"refer-customer-error\">Email address is already associated with an account.</p>").insertBefore($("#swell-referral-refer-emails").parent().parent());;
      $("#swell-referral-refer-emails").addClass("error-border");
    }else if(textStatus && textStatus === "Please enter a valid email address"){
      $('<p class=\"refer-customer-error\">Please enter a valid email addresses.</p>').insertBefore($("#swell-referral-refer-emails").parent().parent());
      $("#swell-referral-refer-emails").parent().parent().addClass("error-border");
    } else if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
      $('<p class=\"refer-customer-error\">Oops, looks like we already know that person. Try another friend\'s email address!</p>').insertBefore($("#swell-referral-refer-emails").parent().parent());
      $("#swell-referral-refer-emails").parent().parent().addClass("error-border");
    }
  });

  $(".swell-tier-arrow").click(function(){
    var current_tier, next_tier ;
    var tiers = spapi.activeVipTiers;
    tiers.forEach(function(tier){
      if($('.swell-tier-table').hasClass(tier.class)){
        current_tier = SwellConfig.Tier.getTierByClass(tier.class);
      }
    });
    if($(this).hasClass("swell-left")){
      if(current_tier.rank == 0){
        next_tier = SwellConfig.Tier.getTierByRank(tiers.length - 1);
      }else{
        next_tier = SwellConfig.Tier.getTierByRank(current_tier.rank - 1);
      }
    }else if($(this).hasClass("swell-right")){
      if(current_tier.rank == tiers.length-1){
        next_tier = SwellConfig.Tier.getTierByRank(0);
      }else{
        next_tier = SwellConfig.Tier.getTierByRank(current_tier.rank + 1);
      }
    }
    if(current_tier && next_tier){
      $(".swell-tier-table").removeClass(current_tier.class);
      $(".swell-tier-table").addClass(next_tier.class);
    }
  });

});

(function() {
   window.SwellConfig = window.SwellConfig || {};

   SwellConfig.Referral = {
      opts: {
         localization: {
          referralSidebarDetailsAction: "",
          referralSidebarDetailsReward: "",

          referralRegisterHeading: "<span class='refer-heading'>Refer a friend</span>Give $10, Get $10",
          referralRegisterDetails: "Give your friends $10 off on their first order of $45+ and get $10 in points for each successful referral.",
          referralRegisterFormDetails: "Enter your email to get started.",
          referralRegisterFormEmail: "Your email",
          referralRegisterFormSubmit: "Next",

          referralReferHeading: "<span class='refer-heading'>Refer a friend</span>Give $10, Get $10",
          referralReferDetails: "Give your friends $10 off on their first order of $45+ and get $10 in points for each successful referral.",
          referralReferFormSubmit: "Send",
          referralReferFormDetails: "Now, enter your friends’ emails.",
          referralReferFormEmailsDetails: "Your friends’ emails (separated by commas)",

          referralReferMediaDetails: "You can also share your link with the buttons below.",

          referralShareFacebook: "Share",
          referralShareMessenger: "Message",
          referralShareTwitter: "Tweet",
          referralShareSMS: "SMS",
          referralShareCopy: "Copy Link",

          referralFacebookIcon: "swell-icon-facebook-share-mob",
          referralMessengerIcon: "swell-icon-fb-message-mob",
          referralTwitterIcon: "swell-icon-tweet-mob",
          referralLinkIcon: "swell-icon-copy-link-mob",
          referralSMSIcon: "swell-icon-sms-mob",

          referralThanksHeading: "Thanks for Referring!",
          referralThanksDetails: "Remind your friends to check their emails.",

          referralCopyHeading: "",
          referralCopyButton: "Copy link",
          referralCopyDetails: "Copy link and share with your friends"
        },
        templates: {
          referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <div class="swell-referral-copy-sidebar"> <div class="swell-copy-img"><img src="//www.sleeknail.com/cdn/shop/t/28/assets/swell-referral-copy-image.png?48152"></div> </div> <div class="swell-referral-copy-main"> <span class="swell-referral-back-link"></span> <div class="swell-referral-form-wrapper"> <div class="swell-referral-copy-link swell-referral-link cross-link-circle" id="swell-referral-copy-link"></div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link"> <%= localization.referralCopyButton %> </button> <p class="swell-referral-details"> <%= localization.referralCopyDetails %> </p> </div> </div> </div> <div> </div> </div>',
          referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmailsDetails %>"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit"><%= localization.referralReferFormSubmit %> </button> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareSMS %> </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralTwitterIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareTwitter %> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareMessenger %> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>',
          referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit"> <%= localization.referralRegisterFormSubmit %> </button> </li> </ul> </div> </form> </div> </div>'
        }
      
      },
      populateReferrals: function(){
        if (spapi.authenticated && spapi.activeReferralCampaign) {
          swellAPI.refreshCustomerDetails(function(){
            var referral_receipts = spapi.customer.referral_receipts;
            $('.table-data tr').remove();
            referral_receipts.forEach(function(referral_receipt) {
               var email = referral_receipt.email;
               var completed_at = referral_receipt.completed_at;
               if (completed_at) {
                  status = "Purchased (" + spapi.activeReferralCampaign.reward_text + ")";
               } else {
                  status = 'Invited';
               }
               $(".table-data").append("<tr><td>" + email + "</td><td>" + status + "</td></tr>");
            });
          });
        }
      },
      initializeReferral: function(containerSelector) {
        var email = $(containerSelector).data("customer-email");
        if (email) {
          spapi.storage.setItem("referrer_email", email);
          spapi.customer.email = email;
        }
        Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
        SwellConfig.Referral.populateReferrals();
      }
   };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    initializeProductRedemptions: function(conntainerSelector){
      var activator = "";
      if ($(conntainerSelector).hasClass("logged-in")) {
        activator = "swell-product-redemption";
      }
      spapi.activeRedemptionOptions.forEach(function(redemption){
        if(redemption.discount_type === "product"){
          $(conntainerSelector).append('<li class="swell-redemption-product"> <div class="swell-redemption-product-content swell-buy-product-btn"  data-variant-id="'+ redemption.applies_to_id + '"" data-success-ok-btn="<span class=\'swell-keep-shopping-btn\'>Keep Shopping</span>" data-redemption-option-id="'+ redemption.id +'"> <div class="product-img-holder"> <img src="'+ redemption.background_image_url +'"> </div> <div class="swell-redemption-option-value">'+ redemption.name +' </div> <div class="swell-redemption-option-cost"><div class="swell-redemtion-cost">'+ redemption.cost_text +'</div></div> <div class="swell-redemption-product-btn '+activator+'" data-variant-id="'+ redemption.applies_to_id +'" data-redemption-option-id="'+ redemption.id +'">Redeem</div> </div> </li>');
        }
      });
      swellAPI.refreshEmbeds();
      SwellConfig.Redemption.applySlickSlider(conntainerSelector);
    },
    initializeRedemptions: function(conntainerSelector){
      var activator = "";
      if ($(conntainerSelector).hasClass("logged-in")) {
        activator = "swell-redemption-link";
      }
      spapi.activeRedemptionOptions.forEach(function(redemption){
        if(redemption.discount_type === "fixed_amount"){
          $(conntainerSelector).append('<li class="swell-redemption-option"> <div class="'+activator+' swell-redemption-option-content" data-redemption-option-id="'+ redemption.id +'"> <div class="swell-redemption-option-cost">'+redemption.name+'</div> <div class="swell-redemption-option-value">'+redemption.cost_text+'</div> </div> </li>');
        }
      });
    },
    applySlickSlider : function(containerSelector){
      $(containerSelector).slick({
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        prevArrow: '<i class="swell-icon-arrow swell-prev"><span class="path1"></span><span class="path2"></span></i>',
        nextArrow: '<i class="swell-icon-arrow swell-next"><span class="path1"></span><span class="path2"></span></i>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              centerMode: true,
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '30px',
            }
          },
          {
            breakpoint: 480,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '10px',
            }
          }
       ]
      });
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    sortTiers:function(tiers){
      if(tiers[0].rank!= 0){
        while(tiers[0].rank!= 0){
          temp = tiers.pop();
          tiers.unshift(temp);
        }
      }
    },
    getTierById : function(id) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.id === id;
      })[0];
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    getTierByClass: function(t_class) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.class === t_class;
      })[0];
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        dummy: true,
        name: "Commuter",
        points: "$0&ndash;$299",
        points_multiplier:" 1",
        exclusive_products: "",
        free_product: "",
        AmountSpent: "$0",
        amount_spent_cents: 0,
        PointsEarned: 0,
        PurchasesMade: 0,
        ReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function() {
      var tiers = spapi.activeVipTiers;
        Tier_0 = SwellConfig.Tier.getTierByRank(0);
        Tier_1 = SwellConfig.Tier.getTierByRank(1);
        Tier_2 = SwellConfig.Tier.getTierByRank(2);
        Tier_3 = SwellConfig.Tier.getTierByRank(3);

      if(Tier_0){
        if(Tier_1){
          Tier_0.spend = "$"+(Tier_0.amount_spent_cents/100)+"-$"+((Tier_1.amount_spent_cents/100)-1); 
        }else{
          Tier_0.spend = "$"+(Tier_0.amount_spent_cents/100)+"+"; 
        }
        Tier_0.multiplier = "1x"; 
        Tier_0.merchandise_giveaway = '<div class="swell-tier-check"><i class="swell-icon-vip-check-1"></i></div>'; 
        Tier_0.exclusive_offer = ""; 
        Tier_0.annual_gift = ''; 
        Tier_0.class = 'tier_0'; 
      }
      if(Tier_1){
        if(Tier_2){
          Tier_1.spend = "$"+(Tier_1.amount_spent_cents/100)+"-$"+((Tier_2.amount_spent_cents/100)-1); 
        }else{
          Tier_1.spend = "$"+(Tier_1.amount_spent_cents/100)+"+"; 
        }
        Tier_1.multiplier = "1.25x"; 
        Tier_1.merchandise_giveaway = '<div class="swell-tier-check"><i class="swell-icon-vip-check-2"></i></div>'; 
        Tier_1.exclusive_offer = '<div class="swell-tier-check"><i class="swell-icon-vip-check-2"></i></div>'; 
        Tier_1.annual_gift = ''; 
        Tier_1.class = 'tier_1'; 
      }
      if(Tier_2){
        if(Tier_3){
          Tier_2.spend = "$"+(Tier_2.amount_spent_cents/100)+"-$"+((Tier_3.amount_spent_cents/100)-1); 
        }else{
          Tier_2.spend = "$"+(Tier_2.amount_spent_cents/100)+"+"; 
        }
        Tier_2.multiplier = "1.5x"; 
        Tier_2.merchandise_giveaway = '<div class="swell-tier-check"><i class="swell-icon-vip-check-3"></i></div>'; 
        Tier_2.exclusive_offer = '<div class="swell-tier-check"><i class="swell-icon-vip-check-3"></i></div>'; 
        Tier_2.annual_gift = '<div class="swell-tier-check"><i class="swell-icon-vip-check-3"></i></div>'; 
        Tier_2.class = 'tier_2'; 
      }
      // if(Tier_3){
      //   Tier_3.spend = "$"+(Tier_3.amount_spent_cents/100)+"+"; 
      //   Tier_3.multiplier = "2x"; 
      //   Tier_3.merchandise_giveaway = '<div class="swell-tier-check"><i class="swell-icon-vip-check"></i></div>'; 
      //   Tier_3.exclusive_offer = '<div class="swell-tier-check"><i class="swell-icon-vip-check"></i></div>'; 
      //   Tier_3.annual_gift = '<div class="swell-tier-check"><i class="swell-icon-vip-check"></i></div>';  
      //   Tier_3.class = 'tier_3'; 
      // }
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          name: {
            className: "swell-tier-names",
            title: "",
          },
          spend: {
            className: "swell-tier-values",
            title: "Benefits"
          }
        },
        body: {
          multiplier: {
            title: "Point Multiplier"
          },
          merchandise_giveaway: {
            title: "Merchandise Giveaway"
          },
          exclusive_offer: {
            title: "Exclusive Offers"
          },
          annual_gift: {
            title: "Annual Gifts"
          }
        }
      };
      $(containerSelector).append('<li class="swell-tier-benefit"><div class="swell-tier-holder"> </div></li>');
      $(containerSelector).append('<li class="swell-tier-properties"><ul class="swell-tier-list">  </ul></li>');
      tiers.forEach(function (tier) {
        return $(containerSelector).find(".swell-tier-properties .swell-tier-list").append('<li class="swell-tier ' + tier.class + '" data-tier-id="' + tier.id + '"> <div class="swell-tier-holder"> </div> </li>');
      });
      j = 0;
      ref = properties.header;
      for (key in ref) {
        property = ref[key];
        $(containerSelector).find(".swell-tier-benefit .swell-tier-holder").append('<div class="swell-tier-items ' + property.className + '"> ' + property.title + '</div>');
        tiers.forEach(function (tier) {
          return $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="' + tier.id + '"] .swell-tier-holder').append('<div class="swell-tier-items ' + property.className + '"> ' + tier[key] + '</div>');
        }); +
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        property = ref1[key];
        $(containerSelector).find(".swell-tier-benefit .swell-tier-holder").append('<div class="swell-tier-items"> ' + property.title + '</div>');
        tiers.forEach(function (tier) {
          return $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="' + tier.id + '"] .swell-tier-holder').append('<div class="swell-tier-items"> ' + tier[key] + '</div>');
        });
        i++;
      }
      $(".swell-tier-benefit").prepend("<div class='swell-current-status'></div>");
      $(".swell-tier").prepend("<div class='swell-current-status'></div>");
      SwellConfig.Tier.applytierSlickSlider('.swell-tier-list');
      if(spapi.authenticated) {
        SwellConfig.Tier.setupCustomerTierStatus();
      }
    },
    applytierSlickSlider: function (containerSelector) {
      $(containerSelector).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToScroll: 1,
        slidesToShow: 3,
        prevArrow: false,
        nextArrow: false,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }]
      });
    },
    setupCustomerTierStatus: function () {
      let spend_required, next_tier, customer_tier_id;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      if(customer_tier_id) {
        $(".swell-tier-list .swell-tier[data-tier-id='"+customer_tier_id+"'] .swell-current-status").prepend("Current Status");
      }

      let customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      if(customer_tier_rank != null) {
        next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      } else {
        next_tier = SwellConfig.Tier.getTierByRank(0);
      }

      if(customer_tier_rank!=2) {
        if(swellAPI.getCustomerDetails().vipTierStats) {
          spend_required = ((next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100);
          $(".swell-tier-list .swell-tier[data-tier-id='"+(customer_tier_id+1)+"'] .swell-current-status").prepend("Spend $" + spend_required + " more for " + next_tier.name);
        } else {
          spend_required = spapi.activeVipTiers[0].prettyAmountSpent;
          $(".swell-tier-list .swell-tier[data-tier-id='2979'] .swell-current-status").prepend("Spend " + spend_required + " more for " + next_tier.name);
        }
      }
    },
  };

}).call(this);
